module.exports = __webpack_public_path__ + "static/media/widgets.34f94c60.svg";